import { useContext, useEffect } from 'react';
import { useGeneralRoutes } from '@namespace/cms';
import { useOtherSettings } from '@namespace/cms/src/hooks/useOtherSettings';
import { useI18n, useLocation } from '@namespace/i18n';
import { CookieManagementContext } from '../../store/context';

const useInitCookieBot = (userInfoLoaded) => {
  const { cookieDeclaration } = useGeneralRoutes();
  const { pathname = '' } = useLocation();
  const { language } = useI18n();
  const isCookieDeclarationPage = pathname.includes(cookieDeclaration);
  const { cookieManagement = {} } = useOtherSettings();
  const {
    isShowCookieManagement = false,
    isCookieBotEnabled = false,
    cookieBotID = ''
  } = cookieManagement;
  const [{ showCookieManagementOnCookieDeclarationPage }] = useContext(
    CookieManagementContext
  );

  useEffect(() => {
    if (
      !language ||
      !userInfoLoaded ||
      !isCookieBotEnabled ||
      !isShowCookieManagement
    ) {
      return undefined;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'Cookiebot';
    script.src = 'https://consent.cookiebot.com/uc.js';
    script.async = true;
    script.setAttribute('data-cbid', cookieBotID);
    script.setAttribute('data-culture', language);

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [
    userInfoLoaded,
    isCookieBotEnabled,
    isCookieDeclarationPage,
    isShowCookieManagement,
    language,
    showCookieManagementOnCookieDeclarationPage
  ]);
};

export default useInitCookieBot;
